import { render, staticRenderFns } from "./companyIdentify.vue?vue&type=template&id=6af8fdb2&scoped=true"
import script from "./companyIdentify.vue?vue&type=script&scoped=true&lang=js"
export * from "./companyIdentify.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./companyIdentify.vue?vue&type=style&index=0&id=6af8fdb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af8fdb2",
  null
  
)

export default component.exports